import React from "react";
import styles from "../stylesER.module.scss";

export const EditCostModal = ({
  isOpen,
  editingConcept,
  editValue,
  setEditValue,
  meses,
  currentYear,
  getMoneda,
  onSave,
  onClose,
}) => {
  if (!isOpen || !editingConcept) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={`${styles.modalContent} ${styles.editCostModal}`} onClick={(e) => e.stopPropagation()}>
        <h3 className={styles.modalTitle}>
          Editar {editingConcept.concept} - {meses[editingConcept.month - 1]} {currentYear}
        </h3>

        <div className={styles.inputGroup}>
          <span className={styles.inputPrefix}>{getMoneda()}</span>
          <input
            type="number"
            value={editValue || 0}
            onChange={(e) => setEditValue(parseFloat(e.target.value) || 0)}
            min="0"
            step="0.01"
            placeholder="0"
          />
        </div>

        <div className={styles.modalActions}>
          <button className={styles.btnSave} onClick={onSave}>
            Guardar
          </button>
          <button className={styles.btnCancel} onClick={onClose}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};
